<div class="dashboard-container">
  <section class="dashboard-section">
    <div class="section-header">
      <mat-icon class="section-icon">person</mat-icon>
      <h2>Benutzerbereich</h2>
    </div>
    <div class="cards-grid">
      @for (card of userCards; track $index) {
        <mat-card
          class="dashboard-card"
          (click)="navigateToCard(card)">
          <mat-card-header>
            <div mat-card-avatar class="card-icon">
              <mat-icon>{{ card.icon }}</mat-icon>
            </div>
            <mat-card-title>{{ card.title }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>{{ card.description }}</p>
          </mat-card-content>
          <mat-card-actions align="end">
            <button matButton>
              Öffnen
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </mat-card-actions>
        </mat-card>
      }
    </div>
  </section>

  @if (isAdmin()) {
    <section class="dashboard-section">
      <div class="section-header admin-header">
        <mat-icon class="section-icon">admin_panel_settings</mat-icon>
        <h2>Administrationsbereich</h2>
      </div>
      <div class="cards-grid">
        @for (card of adminCards; track $index) {
          <mat-card
            class="dashboard-card admin-card"
            (click)="navigateToCard(card)">
            <mat-card-header>
              <div mat-card-avatar class="card-icon admin-icon">
                <mat-icon>{{ card.icon }}</mat-icon>
              </div>
              <mat-card-title>{{ card.title }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <p>{{ card.description }}</p>
            </mat-card-content>
            <mat-card-actions align="end">
              <button matButton>
                Öffnen
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </mat-card-actions>
          </mat-card>
        }
      </div>
    </section>
  }

  <section class="dashboard-section info-section">
    <mat-card class="info-card">
      <mat-card-header>
        <mat-card-title>Benutzerübersicht zum Testen:</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="info-row">
          <mat-icon>person</mat-icon>
          <span><strong>Benutzername:</strong> {{ userProfile()?.username }}</span>
        </div>
        <div class="info-row">
          <mat-icon>email</mat-icon>
          <span><strong>Email:</strong> {{ userProfile()?.email }}</span>
        </div>
        <div class="info-row">
          <mat-icon>badge</mat-icon>
          <span><strong>Rolle:</strong> {{ userRoles().join(', ') || 'Keine Rolle' }}</span>
        </div>
        <div class="info-row">
          <mat-icon>group</mat-icon>
          <span><strong>Gruppe:</strong> {{ userGroups().join(', ') || 'Keine Gruppe' }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  </section>
</div>
